module.exports = __webpack_public_path__ + "media/4.005ba884.mp3";